export const statusList = [
  {
    label: 'Belum Dipacking',
    value: 'submitted',
  },
  {
    label: 'Dipacking',
    value: 'confirmed',
  },
  {
    label: 'Dikirim',
    value: 'shipped',
  },
  {
    label: 'Selesai',
    value: 'completed',
  },
  {
    label: 'Batal',
    value: 'cancelled',
  },
  // {
  //   label: 'Retur',
  //   value: 'retur',
  // },
]

export const MARKETPLACE_FILTER_OPTIONS = [
  {
    disabled: true,
    label: 'Tokopedia',
    value: 'tokopedia',
  },
  {
    label: 'Shopee',
    value: 'shopee',
  },
  {
    disabled: true,
    label: 'Lazada',
    value: 'lazada',
  },
  {
    label: 'TikTok Shop',
    value: 'tiktok',
  },
]

export const MARKETPLACE_PLATFORM = {
  tokopedia: {
    logo: 'https://storage.googleapis.com/komerce/kompack/marketplace-integration/tokopedia-logo.png',
    label: 'Tokopedia',
  },
  shopee: {
    logo: 'https://storage.googleapis.com/komerce/kompack/marketplace-integration/shopee-logo.png',
    label: 'Shopee',
  },
  lazada: {
    logo: 'https://storage.googleapis.com/komerce/kompack/marketplace-integration/lazada-logo.png',
    label: 'Lazada',
  },
  tiktok: {
    logo: 'https://storage.googleapis.com/komerce/komads-meta/tiktok.svg',
    label: 'TikTok Shop',
  },
  kompack: {
    logo: 'https://storage.googleapis.com/komerce/icon/Vector.svg',
    label: 'Kompack',
  },
}
